import type { EXAM_STATUS } from "types/tag";
import { proethicaModuleListMeta as demoProethicaModuleListMeta } from "./praxis-proethica";

export type ProethicaModuleKind = "standard" | "ai_simulation";

export type ProethicaModuleListMeta = {
	title: string;
	titleWithNumber: string;
	thumbnailUrl: string;
	thumbnailSource?: string | number | { uri: string };
	subtitle: string;
	status: EXAM_STATUS;
	durationMinutes: number;
	durationLabel: string;
	activityCount: number;
	knowledgeCheckQuestionCount: number;
	moduleNumber: number;
	moduleKind: ProethicaModuleKind;
	moduleKindLabel: string;
	moduleRef: string;
	disabled: boolean;
};

export const proethicaModuleListMeta = demoProethicaModuleListMeta as Record<
	string,
	ProethicaModuleListMeta
>;
